import React from 'react'

import { ModalManagerProvider as ModalManagerProviderLib } from '@/shared/lib/modal-manager'

import registry from '../config/modals-registry'

export default function ModalManagerProvider({
	children,
}: {
	children: React.ReactNode
}) {
	return (
		<ModalManagerProviderLib registry={registry}>
			{children}
		</ModalManagerProviderLib>
	)
}
